import {graphql} from 'react-relay'

export const buildDependantsQuery = graphql`
  query BuildDependantsQuery($buildLocator: String!) {
    build(buildLocator: $buildLocator) {
      related {
        builds(
          locator: "count:1,defaultFilter:false,item:(count:1,defaultFilter:false,snapshotDependency:(from:(id:$context.build.id),recursive:false)),item:(count:1,defaultFilter:false,state:finished,artifactDependency:(from:(id:$context.build.id),recursive:false))"
        ) {
          count
        }
      }
    }
  }
`
